module.exports = __webpack_public_path__ + "img/Luss.5b5cd514.png";